module.exports = "//static.hsappstatic.net/unified-navigation-ui/static-1.13806/img/default-avatar.png"